// Curated top-50 language list, alphabetical by English name.
export const LANGUAGES = [
  'Arabic','Bengali','Bosnian','Bulgarian','Burmese','Cantonese','Croatian','Czech','Danish',
  'Dutch','English','Estonian','Farsi (Persian)','Filipino (Tagalog)','Finnish','French','German',
  'Greek','Gujarati','Hebrew','Hindi','Hungarian','Indonesian','Italian','Japanese','Kannada',
  'Korean','Malay','Malayalam','Mandarin (Chinese)','Marathi','Nepali','Norwegian','Polish',
  'Portuguese','Punjabi','Romanian','Russian','Serbian','Sinhala','Slovak','Spanish','Swahili',
  'Swedish','Tamil','Telugu','Thai','Turkish','Ukrainian','Urdu','Vietnamese'
];
